/**
* Our Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Our Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'our-services',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      const mobileToggle = document.getElementById( 'mobile-dropdown-toggle' );
      const tabContainer = document.getElementById( 'tab-container' );
      const selectedTabTitle = document.getElementById( 'selected-tab-title' );

      // Mobile dropdown functionality
      if ( mobileToggle && tabContainer ) {
        mobileToggle.addEventListener( 'click', function() {
          if ( window.innerWidth < 768 ) {
            tabContainer.classList.toggle( 'hidden' );
          }
        } );

        tabContainer.querySelectorAll( 'button' ).forEach( ( button ) => {
          button.addEventListener( 'click', () => {
            selectedTabTitle.textContent = button.textContent.trim();
            if ( window.innerWidth < 768 ) {
              tabContainer.classList.add( 'hidden' );
            }

            // Recalculate hover effects when tabs change
            setTimeout( () => {
              this.updateHoverEffects();
            }, 50 );
          } );
        } );
      }

      // Initial hover effect setup
      this.updateHoverEffects();

      // Recalculate on resize
      window.addEventListener( 'resize', () => {
        this.updateHoverEffects();
      } );
    },
    updateHoverEffects: function() {
      const serviceItems = document.querySelectorAll( '.service-item' );

      serviceItems.forEach( ( item ) => {
        const content = item.querySelector( '.service-content' );
        const description = item.querySelector( '.service-description' );

        if ( description && content ) {
          const descHeight = description.offsetHeight + 20;

          // Apply initial transform based on screen size
          if ( window.innerWidth >= 768 ) {
            content.style.transform = `translateY(${descHeight}px)`;
          } else {
            content.style.transform = 'none';
          }

          // Hover effects for desktop
          item.addEventListener( 'mouseenter', () => {
            if ( window.innerWidth >= 768 ) {
              content.style.transform = 'translateY(0)';
            }
          } );

          item.addEventListener( 'mouseleave', () => {
            if ( window.innerWidth >= 768 ) {
              content.style.transform = `translateY(${descHeight}px)`;
            }
          } );
        }
      } );
    },
    finalize: function() {
      // Add any cleanup logic if needed
    },
  };

  app.registerComponent( 'our-services', COMPONENT );
} )( app );
